/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { User } from '../../../../../models/User';

@Component({
  selector: 'app-ctv-overview-risk',
  templateUrl: './ctv-overview-risk.component.html',
  styleUrls: ['./ctv-overview-risk.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvOverviewRiskComponent implements OnChanges {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() byRegionsData: Array<any>;
  @Input() month;
  @Input() isFreemium: boolean;
  @Input() isFollowing: boolean;
  @Output() anchorClick = new EventEmitter<string>();
  @Output() goToDiscovery: EventEmitter<any> = new EventEmitter<any>();
  @Output() followClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  reputation: any;
  dangerousPermissionsCount: number;
  loading: boolean;
  deviceTypes = [
    {
      name: 'smartphone',
      tooltip:
        'Blended advertiser risk assessment for the App on Smartphones by global business region'
    },
    {
      name: 'tablet',
      tooltip:
        'Blended advertiser risk assessment for the App on Tablets by global business region'
    }
  ];
  tooltipTemplate =
    '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner email"></div></div>';
  tooltip: any = {
    'High Fraud': 'Significantly Elevated IVT Percentage',
    'Non-Corporate Email': 'Developer Maintains Non-corporate Email Address',
    'Moderate Fraud': 'Moderately Elevated IVT Percentage',
    'No Privacy Policy': 'Developer Does Not Publish a Privacy Policy',
    'Private Registration Domain':
      'The Developer Hides their Corporate Details in the Domain Registry',
    'Mail Server Domain Different Than Publisher Domain': `The Developer's Email Address Doesn't Match Their Domain`,
    'Adult Content': 'Adult Content Has Been Detected in the App',
    'No Terms Of Service':
      'The Developer Does Not Publish Terms and Conditions',
    'Publisher Domain Not Found': 'The Developer Domain is Invalid',
    'Gambling Content': 'Gambling Content Has Been Detected in the App',
    'No Ads': 'Programmatic Ads Not Detected Leads to High Spoofing Risk',
    'Violence Content': 'Violent Content Has Been Detected in the App',
    'Very Brand Unsafe Description':
      'App Description Uses Brand Unsafe Keywords',
    'Alcohol Content': 'Alchol Based Content Has Been Detected in the App',
    'Moderately Suspicious Traffic Characteristics':
      'Ad Traffic Shows Some Suspicious Characteristics',
    'Profanity Content':
      'Profanity and Offensive Language Has Been Detected in the App',
    'Brand Unsafe Description':
      'App Description Uses Some Brand Unsafe Language',
    'High Click Fraud': 'App Has a High Frequency of Invalid Clicks'
  };
  regionArray = ['GLOBAL', 'NA', 'EMEA', 'LATAM', 'APAC'];
  byRegions: Array<any>;
  hasPublisherScores: boolean;
  hasReputation: boolean;

  constructor(public _userService: User) {}

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'data') {
        if (!this.isFreemium && this.data.overview.reputation) {
          this.loading = true;
          this.reputation = JSON.parse(
            JSON.stringify(this.data.overview.reputation)
          );
          for (const deviceType of this.deviceTypes) {
            for (const region of this.reputation[deviceType.name]) {
              const reasonCodes = region.pixalateGradeReasonCode;
              if (
                reasonCodes &&
                reasonCodes !== 'N/A' &&
                Array.isArray(reasonCodes) &&
                reasonCodes.length > 0
              ) {
                const reasonCodeArr = [];
                for (const code of reasonCodes) {
                  reasonCodeArr.push(
                    this.tooltip[code] ? this.tooltip[code] : code
                  );
                }
                region.pixalateGradeReasonCodeHtml =
                  reasonCodeArr.join('<br/>');
              }
            }
          }

          const dangerousPermissions = this.data['permissions']['all'].filter(
            permission => {
              return (
                permission.isDangerous &&
                permission.effects.indexOf('Privacy') >= 0
              );
            }
          );
          this.dangerousPermissionsCount = dangerousPermissions.length;
          this.loading = false;
        }

        this.hasPublisherScores =
          this.data.ranking && Object.keys(this.data.ranking).length > 0;
      }

      if (propName === 'byRegionsData') {
        const byRegions = [];
        if (this.byRegionsData && this.byRegionsData.length > 0) {
          this.byRegionsData.forEach(riskbar => {
            const byRegion = JSON.parse(JSON.stringify(riskbar));
            const pixalateScoreReasonCode = byRegion.pixalateScoreReasonCode;
            let html = '';
            if (pixalateScoreReasonCode) {
              pixalateScoreReasonCode.forEach(reasonCode => {
                if (this.tooltip[reasonCode]) {
                  html += `<div>${this.tooltip[reasonCode]}</div>`;
                } else {
                  html += `<div>${reasonCode}</div>`;
                }
              });
            }
            byRegion.pixalateScoreReasonCodeHTML = html;
            byRegions.push(byRegion);
            this.hasReputation = true;
          });
          this.byRegions = [];
          this.regionArray.forEach(region => {
            const foundRegion = byRegions.filter(
              byRegion => byRegion.countryCode === region
            );
            if (foundRegion && foundRegion[0]) {
              this.byRegions.push(foundRegion[0]);
            }
          });
        }
      }
    }
  }

  follow(): void {
    this.followClick.emit(true);
  }

  goToDiscoveryClick(data: any) {
    this.goToDiscovery.emit(data);
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }
}
